import { FC, useEffect, useContext, useState, useLayoutEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { format } from "date-fns";

import { GeographicalStatisticsObject } from "./types";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";

import CaseVolume from "src/components/manufacturer/caseVolumeLineChart";
import GeographicalStatistics from "src/components/manufacturer/geographicalStatistics";
import CaseFilter from "src/components/manufacturer/statistics";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import {AuthContext} from "../../context/authContext";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import { StatisticsApiResponse } from "../manufacturer/types";
import CustomPieChart from "src/components/manufacturer/customPieChart";
import CustomComponentDoctor from "src/components/manufacturer/customDoctor";
import { isZilrettaUser } from "src/helpers";
import FooterText from "src/components/footerText";
import IoveraDoctorStats from "src/components/manufacturer/ioveraDoctorStats";
import ZilrettaDoctorStats from "src/components/manufacturer/zilrettaDoctorStats";
import AllProductDoctorStats from "src/components/manufacturer/allProductDoctorStats";


const DoctorStats: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData, destroySession } = useContext(AuthContext);
  const navigate = useNavigate()
  const [searchParams, updateSearchParams] = useSearchParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const insuranceName:string | null = params.get('insurance_name');
  const [drug,setDrugName] = useState<string>(params.get('drug') || "");

  const [queryParams, changeQueryParams] = useState({
    start_date:
      searchParams.get("start_date") ||
      format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
    end_date:
      searchParams.get("end_date") ||
      format(new Date().setDate(new Date().getDate()+1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "",
    filter_type: searchParams.get("filter") || "",
    // time: searchParams.get("time") || "",
    type: "doctor_stats",
    role:searchParams.get("role") || "",
    soc_value:searchParams.get("soc_value") || "",
    drug_id:searchParams.get("drug_id") === 'all products' ? "" : searchParams.get("drug_id") === 'all products'  || drug  === 'iovera'? 'iovera°' : drug === "all products" ? "" : drug || "",
    id: searchParams.get("userId") || searchParams.get("id") || (userData && userData.ref_type?.toLowerCase() !== "manufacturer" ? userData.id.toString() : "") || "",
    insurance_name:insuranceName,
    case_id:'',
    global_patient_id:""

  });
   const tabs = [
    { id: "all products", label: "All Products", drugId: "", component: AllProductDoctorStats, specialClass: '', btnClass: 'allproduct-btn' },
    { id: "zilretta", label: "ZILRETTA", drugId: "ZILRETTA", component: ZilrettaDoctorStats, specialClass: 'zilretta-content', btnClass: 'zilretta-btn' },
    { id: "iovera", label: "iovera°", drugId: "iovera°", component: IoveraDoctorStats, specialClass: 'iovera-content', btnClass: 'iovera-btn' },
  ];
  const [activeTab, setActiveTab] = useState(isZilrettaUser(userData) ? tabs[1].id : searchParams.get("drug") || tabs[0].id);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeDrug, setActiveDrug] = useState(isZilrettaUser(userData) ? tabs[1].drugId : searchParams.get("drug") || tabs[0].drugId);

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.message && statisticsData.message.includes("User is a physician user")) {
        showToast(["Your session is expred. Please sign in again to continue", "Your role has been updated from another session."], ToastTypes.INFO)
        destroySession()
        navigate("/users/sign_in")
      }
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);



  const updateQueryParamsAndCallAPI = (
    updatedQueries: StatisticsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate()),
          "yyyy-MM-dd"
        ),
        period: "",
        filter_type: "",
        // time: "",
        type: "territories",
        role: userData ? userData.ref_type.toLowerCase() : searchParams.get("role") || "",
        soc_value:"",
        drug_id:drug  === 'iovera'? 'iovera°' : drug,
        id: "",
        insurance_name:'',
        case_id:"",
         global_patient_id:""

      });
    } else {
      changeQueryParams(updatedQueries);
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = () => {
    const updatedQueries = {
      ...queryParams,
       drug_id: drug  === 'iovera'? 'iovera°' : drug
    }
    setDrugName(drug);
    changeQueryParams(updatedQueries)
    setLoader()
    getStatsData({}, {}, updatedQueries);
  }
   const getDrugData = (drug: string) => {
    const updatedQueries = {
      ...queryParams,
      drug_id: drug
    }
    // setDrugName(drug);
    changeQueryParams(updatedQueries)
    setLoader()
    getStatsData({}, {}, updatedQueries)}

   const handleTabClick = (tab: (typeof tabs)[0]) => {
    setActiveTab(tab.id);
    setActiveDrug(tab.drugId);
    getDrugData(tab.drugId); // still call your API
  }

 return (
  <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
    <div className="container-fluid pt-3 d-flex flex-column flex-fill">
      {/* Tabs */}
      <div
        className="nav nav-pills gap-2 sticky-top bg-white p-2 rounded-2 border shadow-sm"
        id="pills-tab"
      >
        {tabs
          .filter((tab) =>
            isZilrettaUser(userData) ? tab.id.toLowerCase() === "zilretta" : true
          )
          .map((tab) => (
            <button
              key={tab.id}
              className={`nav-link ${tab.btnClass} ${
                activeTab === tab.id ? "active" : ""
              }`}
              id={`${tab.id}-tab`}
              type="button"
              onClick={() => handleTabClick(tab)}
            >
              {tab.label}
            </button>
          ))}
      </div>

      {/* Tab Content */}
      <div
        className="tab-content d-flex flex-column flex-fill"
        id="pills-tabContent"
      >
        {tabs
          .filter((tab) =>
            isZilrettaUser(userData) ? tab.id.toLowerCase() === "zilretta" : true
          )
          .map((tab) => {
            const TabComponent = tab.component;
            return (
              <div
                key={tab.id}
                className={`tab-pane fade flex-fill ${tab.specialClass} ${
                  activeTab === tab.id ? "show active" : ""
                }`}
                id={tab.id}
              >
                {statisticsData && statisticsData.data && activeTab === tab.id ? (
                  <TabComponent
                    updateQueryParamsAndCallAPI={updateQueryParamsAndCallAPI}
                    statisticsData={statisticsData}
                    getStatisticsData={getStatisticsData}
                    queryParams={queryParams}
                    drug={tab.id}
                  />
                ) : null}
              </div>
            );
          })}
      </div>
    </div>

    <FooterText footerType="black" />
  </div>
);
};

export default DoctorStats;
